// Generated by project-provider-summary; do not edit.
export const expectedProviderSummarySHA256 = "sha256:cf5ca0baf62a8ca6e92a668598860255e538840f0366a3ff67578e63d28a3221";
export const expectedProviderSummaryURL = "/lab-data/provider-summary-cf5ca0baf62a8ca6e92a668598860255e538840f0366a3ff67578e63d28a3221.json";
